import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
const firebaseConfig = {
   apiKey: "AIzaSyCCKmh0DHOSjdvMCTvBX2MGDXS34xwOBhU",
  authDomain: "park-ease-valet.firebaseapp.com",
  projectId: "park-ease-valet",
  storageBucket: "park-ease-valet.firebasestorage.app",
  messagingSenderId: "544054856516",
  appId: "1:544054856516:web:c377732dff88309b7aa511",
  measurementId: "G-7YV8FQM5MW"
};
const app = initializeApp(firebaseConfig);
let analytics;
if (typeof window !== "undefined") {
  analytics = getAnalytics(app);
}
const messaging = getMessaging(app);
export { analytics, messaging };